<template>
    <div>

        <MessageOverlay ref="overlay"/>

        <LoadingSendingMail :value="loadingEmail" />

        <v-card class="mx-auto" max-width="1300">
            <v-card-title>
                <div style="min-width: 30%; max-width: 70%">
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        :label="$vuetify.lang.t('$vuetify.users.search')"
                        outlined
                        single-line
                        hide-details
                    ></v-text-field>
                </div>
                <v-spacer />
                <v-btn
                    class="gradient-wintech"
                    @click="addUser"
                    v-if="user.role == 'ADMINISTRATION'"
                >
                    <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-account-plus</v-icon>
                    <template v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.lang.t('$vuetify.users.invite') }}</template>
                </v-btn>
            </v-card-title>
            <v-dialog
                v-model="editDialog"
                max-width="700"
                persistent
            >
                <v-card>
                    <v-card-title>
                        <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text class="px-2 px-sm-6">
                        <div class="text-right text-subtitle-2 font-weight-regular">* {{ $vuetify.lang.t('$vuetify.users.required') }}</div>
                        <v-form
                            ref="editForm"
                            v-model="editFormValidation"
                            lazy-validation
                        >
                            <v-text-field
                                v-model="editedItem.username"
                                outlined
                                disabled
                                :label="$vuetify.lang.t('$vuetify.users.username')"
                            ></v-text-field>
                            <v-text-field
                                v-model="editedItem.email"
                                outlined
                                disabled
                                :label="$vuetify.lang.t('$vuetify.users.email')"
                                @input="isNewEmail = true"
                            ></v-text-field>
                            <vue-tel-input-vuetify
                                outlined
                                placeholder=""
                                appendIcon="$dropdown"
                                mode="international"
                                type="tel"
                                disabled
                                :value="editedItem.phone"
                                :label="this.$vuetify.lang.t('$vuetify.users.phonenumber')"
                                :select-label="this.$vuetify.lang.t('$vuetify.users.country')"
                                :valid-characters-only="true"
                            ></vue-tel-input-vuetify>
                            <v-select
                                required
                                outlined
                                @change="onChangePermission"
                                :label="$vuetify.lang.t('$vuetify.users.role') + '*'"
                                :value="editedItem.role"
                                :items="['CONSULTATION', 'EXPLOITATION', 'ADMINISTRATION']"
                                :rules="[v => !!v || $vuetify.lang.t('$vuetify.users.roleRequired')]"
                            ></v-select>
                        </v-form>
                        <fieldset class="mb-2 mt-n2" style="border-width: 1px; border-color: rgba(0, 0, 0, 0.38); border-style: solid; border-radius: 4px; font-size: 13px;">
                            <legend class="ml-2 px-1" style="letter-spacing: normal">
                                <v-tooltip bottom max-width="400px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-on="on" v-bind="attrs">
                                            Notifications
                                            <v-icon size="18" color="rgba(62,143,197,1)">
                                                mdi-information
                                            </v-icon>
                                        </div>
                                    </template>
                                    <span>
                                        <div class="text-subtitle-2 font-weight-regular mb-2">
                                            <strong>NB:</strong> {{ $vuetify.lang.t('$vuetify.users.nb1') }}<br>{{ $vuetify.lang.t('$vuetify.users.nb2') }}
                                        </div>
                                    </span>
                                </v-tooltip>
                            </legend>
                            <v-simple-table fixed-header height="245">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="px-1 px-sm-2 text-center">
                                                <v-icon>mdi-bell</v-icon>
                                                <div>{{ $vuetify.lang.t('$vuetify.users.event') }}</div>
                                            </th>
                                            <th class="px-1 px-sm-2 text-center">
                                                <v-icon>mdi-email</v-icon>
                                                <div>{{ $vuetify.lang.t('$vuetify.users.sendmail') }}</div>
                                            </th>
                                            <th class="px-1 px-sm-2 text-center">
                                                <v-icon>mdi-cellphone-message</v-icon>
                                                <div>{{ $vuetify.lang.t('$vuetify.users.sendSMS') }}<sup>(1)</sup></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(event, i) in events" :key="i">
                                            <td class="px-1 px-sm-2">
                                                {{ $vuetify.lang.current=='en' ? event.prettyNameEN : event.prettyNameFR }}
                                                <sup v-if="event.adminDefaultEnabled === 1">(2)</sup>
                                                <sup v-if="event.name==='ALARM' || event.name==='INTRUSION'">(3)</sup>
                                            </td>
                                            <td class="px-1 px-sm-2 text-center">
                                                <v-switch
                                                    v-if="event.supervisionMailAvailable===1"
                                                    v-model="event.boolMail"
                                                    dense
                                                    inset
                                                    :disabled="editedItem.role === 'ADMINISTRATION' && event.adminDefaultEnabled === 1"
                                                    hide-details
                                                    class="pt-0 mt-0 justify-center d-inline-block"
                                                ></v-switch>
                                            </td>
                                            <td class="px-1 px-sm-2 text-center">
                                                <v-switch
                                                    v-if="event.supervisionSMSAvailable===1 && twilioAccount"
                                                    v-model="event.boolSMS"
                                                    dense
                                                    inset
                                                    hide-details
                                                    class="pt-0 mt-0 justify-center d-inline-block"
                                                ></v-switch>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </fieldset>
                        <span>
                            <div class="text-subtitle-2 font-weight-regular">(1) {{ $vuetify.lang.t('$vuetify.users.warning') }}</div>
                            <div class="text-subtitle-2 font-weight-regular">(2) {{ $vuetify.lang.t('$vuetify.users.info') }}</div>
                            <div class="text-subtitle-2 font-weight-regular">(3) {{ $vuetify.lang.t('$vuetify.users.notifutc') }}</div>
                        </span> 
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            :disabled="!editFormValidation"
                            :class="{ 'gradient-wintech': (editFormValidation) }"
                            @click="validateEdit"
                        >
                            <v-icon left>mdi-content-save</v-icon>
                            {{ $vuetify.lang.t('$vuetify.users.validate') }}
                        </v-btn>
                        <v-btn
                            color="error"
                            @click="closeEditDialog"
                        >
                            <v-icon left>mdi-cancel</v-icon>
                            {{ $vuetify.lang.t('$vuetify.users.cancel') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>



            <v-dialog
                v-model="inviteDialog"
                max-width="700"
                persistent
            >
                <v-card>
                    <v-card-title>
                        <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text class="px-2 px-sm-6">
                        <div class="text-right text-subtitle-2 font-weight-regular mb-1">* {{ $vuetify.lang.t('$vuetify.users.required') }}</div>
                        <v-form
                            ref="inviteForm"
                            v-model="inviteFormValidation"
                            lazy-validation
                        >
                            <v-text-field
                                v-model="invitedItem.email"
                                required
                                outlined
                                clearable
                                :rules="emailRules"
                                :label="$vuetify.lang.t('$vuetify.users.email') + '*'"
                                @input="isNewEmail = true"
                            ></v-text-field>
                           
                            <v-select
                                required
                                outlined
                                @change="onChangePermissionInvite"
                                :label="$vuetify.lang.t('$vuetify.users.role')"
                                :value="invitedItem.role"
                                :items="['CONSULTATION', 'EXPLOITATION', 'ADMINISTRATION']"
                                :rules="[v => !!v || $vuetify.lang.t('$vuetify.users.roleRequired')]"
                            ></v-select>
                        </v-form>
                        <fieldset class="mb-2" style="border-width: 1px; border-color: rgba(0, 0, 0, 0.38); border-style: solid; border-radius: 4px; font-size: 13px;">
                            <legend class="ml-2 px-1" style="letter-spacing: normal">
                                <v-tooltip bottom max-width="400px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-on="on" v-bind="attrs">
                                            Notifications
                                            <v-icon size="18" color="rgba(62,143,197,1)">
                                                mdi-information
                                            </v-icon>
                                        </div>
                                    </template>
                                    <span>
                                        <div class="text-subtitle-2 font-weight-regular mb-2">
                                            <strong>NB:</strong> {{ $vuetify.lang.t('$vuetify.users.nb1') }}<br>{{ $vuetify.lang.t('$vuetify.users.nb2') }}
                                        </div>
                                    </span>
                                </v-tooltip>
                            </legend>
                            <v-simple-table fixed-header height="245">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="px-1 px-sm-2 text-center">
                                                <v-icon>mdi-bell</v-icon>
                                                <div>{{ $vuetify.lang.t('$vuetify.users.event') }}</div>
                                            </th>
                                            <th class="px-1 px-sm-2 text-center">
                                                <v-icon>mdi-email</v-icon>
                                                <div>{{ $vuetify.lang.t('$vuetify.users.sendmail') }}</div>
                                            </th>
                                            <th class="px-1 px-sm-2 text-center">
                                                <v-icon>mdi-cellphone-message</v-icon>
                                                <div>{{ $vuetify.lang.t('$vuetify.users.sendSMS') }}<sup>(1)</sup></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(event, i) in events" :key="i">
                                            <td class="px-1 px-sm-2">
                                                {{ $vuetify.lang.current=='en' ? event.prettyNameEN : event.prettyNameFR }}
                                                <sup v-if="event.adminDefaultEnabled === 1">(2)</sup>
                                                <sup v-if="event.name==='ALARM'">(3)</sup>
                                            </td>
                                            <td class="px-1 px-sm-2 text-center">
                                                <v-switch
                                                    v-if="event.supervisionMailAvailable===1"
                                                    v-model="event.boolMail"
                                                    dense
                                                    inset
                                                    :disabled="invitedItem.role === 'ADMINISTRATION' && event.adminDefaultEnabled === 1"
                                                    hide-details
                                                    class="pt-0 mt-0 justify-center d-inline-block"
                                                ></v-switch>
                                            </td>
                                            <td class="px-1 px-sm-2 text-center">
                                                <v-switch
                                                    v-if="event.supervisionSMSAvailable===1 && twilioAccount"
                                                    v-model="event.boolSMS"
                                                    dense
                                                    inset
                                                    hide-details
                                                    class="pt-0 mt-0 justify-center d-inline-block"
                                                ></v-switch>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </fieldset>
                        <span>
                            <div class="text-subtitle-2 font-weight-regular">(1) {{ $vuetify.lang.t('$vuetify.users.warning') }}</div>
                            <div class="text-subtitle-2 font-weight-regular">(2) {{ $vuetify.lang.t('$vuetify.users.info') }}</div>
                            <div class="text-subtitle-2 font-weight-regular">(3) {{ $vuetify.lang.t('$vuetify.users.notifutc') }}</div>
                        </span> 
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            :disabled="!inviteFormValidation"
                            :class="{ 'gradient-wintech': (inviteFormValidation) }"
                            @click="validateInvite"
                        >
                            <v-icon left>mdi-content-save</v-icon>
                            {{ $vuetify.lang.t('$vuetify.users.validate') }}
                        </v-btn>
                        <v-btn
                            color="error"
                            @click="closeEditDialog"
                        >
                            <v-icon left>mdi-cancel</v-icon>
                            {{ $vuetify.lang.t('$vuetify.users.cancel') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>


            <v-dialog v-model="deleteDialog" max-width="700" persistent>
                <v-card>
                    <v-card-title class="text-h5 text-center">{{ $vuetify.lang.t('$vuetify.users.areyousureyouwanttodeletethisuser') }}</v-card-title>
                    <v-card-title class="text-h5 text-center">{{ $vuetify.lang.t('$vuetify.users.thisuserwillnotbeabletoreconnect') }}</v-card-title>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            :class="'gradient-wintech'"
                            @click="deleteItemConfirm"
                        >
                            <v-icon left>mdi-content-save</v-icon>
                            {{ $vuetify.lang.t('$vuetify.users.validate') }}
                        </v-btn>
                        <v-btn
                            color="error"
                            @click="closeDeleteDialog"
                        >
                            <v-icon left>mdi-cancel</v-icon>
                            {{ $vuetify.lang.t('$vuetify.users.cancel') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-data-table
                :headers="user.role == 'ADMINISTRATION' ? headers : headersConsult"
                :items="users"
                :search="search"
                item-key="username"
                :loading="loading"
                sort-by="username"
            >
            
                <template v-slot:[`item.username`]="{ item }" >
                    <td align="center">
                        <v-icon v-if="item.id === user.id && developer"
                            small
                            color="red'"
                            @click="deleteItem(item)"
                        >
                            mdi-delete
                        </v-icon>
                        {{ item.username }}
                    </td>
                </template>

                <template v-slot:[`item.contact`]="{ item }" >
                    <template>
                        <v-icon
                            class="mr-2"
                            :color="item.mailCount > 0 ? 'green' : 'grey'"
                            :disabled="item.mailCount === 0"
                        >
                            mdi-email
                        </v-icon>
                        <v-icon
                            :color="item.SMSCount > 0 ? 'green' : 'grey'"
                            :disabled="item.SMSCount === 0"
                        >
                            mdi-cellphone-message
                        </v-icon>
                    </template>
                </template>
                <template v-slot:[`item.invitationStatus`]="{ item }" >
                    <template>
                        <v-icon color="black">
                            {{item.invitationStatus ? 'mdi-sync':'mdi-check'}}
                        </v-icon>
                    </template>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <template v-if="item.id !== user.id">
                        <v-icon 
                            small
                            class="mr-2"
                            color="black"
                            @click="editItem(item)"
                        >
                            mdi-pencil
                        </v-icon>
                        <v-icon
                            small
                            color="black'"
                            @click="deleteItem(item)"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import _ from 'lodash';
import LoadingSendingMail from './Overlay/LoadingSendingMail.vue';
import MessageOverlay from './Overlay/MessageOverlay.vue';

export default {
    name: "Users",
    components: {
        LoadingSendingMail,
        MessageOverlay
    },
    data() {
        
        return {
            editDialog: false,
            inviteDialog: false,
            deleteDialog: false,
            search: "",
            editFormValidation: true,
            inviteFormValidation: true,
            isNewEmail: true,
            events: [],
            eventsSave: [],
            headers: [
                {
                    text: this.$vuetify.lang.t('$vuetify.users.username'),
                    class: 'table-header-text',
                    value: 'username',
                    sortable: true,
                    align: 'center',
                    filterable: true,
                    width: "15%"
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.users.role'),
                    class: 'table-header-text',
                    value: 'role',
                    sortable: true,
                    align: 'center',
                    filterable: true,
                    width: "15%"
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.users.email'),
                    class: 'table-header-text',
                    value: 'email',
                    sortable: true,
                    align: 'center',
                    filterable: true,
                    width: "30%"
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.users.phone'),
                    class: 'table-header-text',
                    value: 'phone',
                    sortable: true,
                    align: 'center',
                    filterable: true,
                    width: "15%"
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.users.invitationStatus'),
                    class: 'table-header-text',
                    value: 'invitationStatus',
                    sortable: false,
                    align: 'center',
                    filterable: false,
                    width: "15%"
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.users.notifications'),
                    class: 'table-header-text',
                    value: 'contact',
                    sortable: false,
                    align: 'center',
                    filterable: false,
                    width: "15%"
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.users.actions'),
                    class: 'table-header-text',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    filterable: false,
                    width: "10%"
                },
            ],
            headersConsult: [
                {
                    text: this.$vuetify.lang.t('$vuetify.users.username'),
                    class: 'table-header-text',
                    value: 'username',
                    sortable: true,
                    align: 'center',
                    filterable: true,
                    width: "15%"
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.users.role'),
                    class: 'table-header-text',
                    value: 'role',
                    sortable: true,
                    align: 'center',
                    filterable: true,
                    width: "15%"
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.users.email'),
                    class: 'table-header-text',
                    value: 'email',
                    sortable: true,
                    align: 'center',
                    filterable: true,
                    width: "30%"
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.users.phone'),
                    class: 'table-header-text',
                    value: 'phone',
                    sortable: true,
                    align: 'center',
                    filterable: true,
                    width: "15%"
                },
                {
                    text: 'Notifications',
                    class: 'table-header-text',
                    value: 'contact',
                    sortable: false,
                    align: 'center',
                    filterable: false,
                    width: "15%"
                },
            ],
            users: [],
            editedIndex: -1,

            deleteUserId: undefined,

            editedItem: {
                username: '',
                role: '',
                email: '',
                phone: ''
            },
            invitedItem: {
                role: '',
                email: ''
            },
            defaultItem: {
                username: '',
                role: '',
                email: '',
                phone: ''
            },
            isPhoneInputValid: false,
            loading: true,
            
            loadingEmail: false,
            twilioAccount: false,
            developer: false,
        }
    },
    computed: {
        ...mapGetters({ user: "StateUser" }),
        formTitle () {
            return this.editedIndex === -1 ? this.$vuetify.lang.t('$vuetify.users.newuser') : this.$vuetify.lang.t('$vuetify.users.edituser')
        },
        emailRules() {
            return [
                v => !!v || this.$vuetify.lang.t('$vuetify.users.emailisrequired') ,
                v => /.+@.+\..+/.test(v) || this.$vuetify.lang.t('$vuetify.users.emailmustbevalid'),
                this.isNewEmail || this.$vuetify.lang.t('$vuetify.users.emailalreadyinuse')
            ]
        },
    },
    async created() {
        try {
            const res = await axios.get('users/'+this.user.orga);
            if (res.status === 200) {
                this.users = res.data.users;
                this.twilioAccount = res.data.twilioAccount;
            }
        } catch (error) {
            this.$refs.overlay.showOverlay("error", error);
        }
        this.loading = false;

        try {
            const res = await axios.get('users/dev/'+this.user.id);
            if (res.status === 200) {
                this.developer = res.data.dev;
            }
        } catch (error) {
            console.error(error);
        }

    },
    methods: {
        async addUser() {
            await this.getEvents(this.editedIndex, this.user.orga);
            this.inviteDialog = true;
        },

        async editItem(item) {
            this.isNewEmail = true;
            this.editedIndex = this.users.indexOf(item);
            this.editedItem = Object.assign({}, item);
            await this.getEvents(item.id, this.user.orga);
            this.editDialog = true;
        },

        deleteItem(item) {
            this.editedIndex = this.users.indexOf(item);
            this.deleteUserId = this.users[this.editedIndex].id;
            this.deleteDialog = true;
        },

        async deleteItemConfirm() {
            try {
                const res = await axios.delete('users/user/' + this.deleteUserId+'/'+ this.user.orga);
                if (res && res.status == 200) {
                    this.users.splice(this.editedIndex, 1);
                    this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.users.deleteUserOK'))
                }
            } catch (error) {
                this.$refs.overlay.showOverlay("error", error);
            }
            this.editedItem = Object.assign({}, this.users);
            this.closeDeleteDialog();
        },

        closeEditDialog() {
            this.editDialog = false;
            this.inviteDialog = false; // here or in new func ?
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.invitedItem = {
                    role: '',
                    email: ''
                },
                this.events = [];
                this.eventsSave = [];
                this.editedIndex = -1
                this.isNewEmail = true;
            })
        },

        closeDeleteDialog() {
            this.deleteDialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        async validateEdit() {
            try {
                if (this.$refs.editForm.validate()) {
                    const notifications = this.events.map(({ idEvent, idUser, boolMail, boolSMS }) => ({ idEvent, idUser, boolMail, boolSMS }));
                    const data = {
                        ...this.editedItem,
                        notifications: notifications
                    }
                    if (this.editedIndex > -1) {
                        const res = await axios.put('users/user/' + this.editedItem.id + '/'+this.user.orga, data);
                        if (res.status == 200) {
                            this.editedItem.mailCount = notifications.filter((notif) => notif.boolMail).length;
                            this.editedItem.SMSCount = notifications.filter((notif) => notif.boolSMS).length;
                            Object.assign(this.users[this.editedIndex], this.editedItem);
                            this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.users.editUserOK'));
                        }
                    } 
                    this.closeEditDialog();
                }
            } catch(error) {
                if ('response' in error && error.response.status === 409) this.isNewEmail = false;
                else {
                    this.closeEditDialog();
                    this.$refs.overlay.showOverlay("error", error);
                }
            }
        },

        async validateInvite() {
            try {
                if (this.$refs.inviteForm.validate()) {
                    const notifications = this.events.map(({ idEvent, idUser, boolMail, boolSMS }) => ({ idEvent, idUser, boolMail, boolSMS }));
                    const data = {
                        ...this.invitedItem,
                        notifications: notifications
                    }
                    if (this.editedIndex <= -1) {
                        this.loadingEmail=true;
                        const res = await axios.post('users/user/'+this.user.orga, data);
                        if (res.status == 200) {
                            this.invitedItem.id = res.data;
                            this.invitedItem.invitationStatus = true;
                            this.users.push(this.invitedItem);
                        }
                        this.loadingEmail=false;
                    }  
                    this.closeEditDialog();
                    this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.users.newUserOK'));
                }
            } catch(error) {
                if ('response' in error && error.response.status === 409){
                    this.$refs.overlay.showOverlay("error", this.$vuetify.lang.t('$vuetify.users.emailAlreadyExistOnThisOrganization'));
                    this.loadingEmail=false;
                    this.isNewEmail = false;
                } 
                else {
                    this.closeEditDialog();
                    this.$refs.overlay.showOverlay("error", error);
                }
            }
        },

        async getEvents(idUser, idOrga){
            try {
                const res = await axios.get('users/event/'+idUser+'/'+idOrga);
                if (res.status === 200) {
                    this.events = res.data.events;
                    this.eventsSave = res.data.events;
                    this.twilioAccount = res.data.twilioAccount;
                }
            } catch (error) {
                this.$refs.overlay.showOverlay("error", error);
            }
        },

        onChangePermission(newPermission) {
            if (["CONSULTATION", "EXPLOITATION"].indexOf(this.editedItem.role) > -1) {
                this.eventsSave = _.cloneDeep(this.events);
            } else {
                for (const index in this.events ){
                    this.eventsSave[index].boolSMS = this.events[index].boolSMS
                    if(["ALARM", "ALERT", "INTRUSION"].indexOf(this.events[index].name) < 0 ){
                        this.eventsSave[index].boolMail = this.events[index].boolMail
                    }
                }
            }
            if (["CONSULTATION", "EXPLOITATION"].indexOf(newPermission) > -1) {
                this.events = _.cloneDeep(this.eventsSave);
            } else {
                this.events = this.events.map(event => {
                    return { ...event, 
                        boolMail: event.adminDefaultEnabled || event.boolMail
                    }
                });
            }
            this.editedItem.role = newPermission;
        },
        onChangePermissionInvite(newPermission) {
            if (["CONSULTATION", "EXPLOITATION"].indexOf(this.invitedItem.role) > -1) {
                this.eventsSave = _.cloneDeep(this.events);
            } else {
                for (const index in this.events ){
                    this.eventsSave[index].boolSMS = this.events[index].boolSMS
                    if(["ALARM", "ALERT", "INTRUSION"].indexOf(this.events[index].name) < 0 ){
                        this.eventsSave[index].boolMail = this.events[index].boolMail
                    }
                }
            }
            if (["CONSULTATION", "EXPLOITATION"].indexOf(newPermission) > -1) {
                this.events = _.cloneDeep(this.eventsSave);
            } else {
                this.events = this.events.map(event => {
                    return { ...event, 
                        boolMail: event.adminDefaultEnabled || event.boolMail
                    }
                });
            }
            this.invitedItem.role = newPermission;
        }
    },
}
</script>
<style scoped>
.v-input--switch >>> .v-input--selection-controls__input {
    margin-right: -12px;
}
</style>